import React from "react";
import ForecastDiarioModalTopo from "./forecastDiarioModalTopo";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import ForecastDiarioModalGrid from "./forecastDiarioModalGrid";
import ForecastDiarizado from "../../components/classes/ForecastDiarizado";

import { useTranslation } from "react-i18next";

export default function ForecastDiarioModal(props: ForecastDiarioModalPropsTypes) {
  const { t } = useTranslation();

  return (
    <>
      <div className="containerForecastModal">
        <div className="containerTitleModal">
          <ForecastDiarioModalTopo />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t("pages.dailyForecast.text.exitModal")}>
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <ForecastDiarioModalGrid forecastsDiarizados={props.forecastsDiarizados} />
        </div>
      </div>
    </>
  );
}

interface ForecastDiarioModalPropsTypes {
  handleClose?: any;
  forecastsDiarizados?: ForecastDiarizado[];
}
